import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AppConfig, ProductionTypes } from '@shared/utils/app-config';

export function TenantGuard(allowedProductionTypes: ProductionTypes[] = []): CanActivateFn {
  return () => {
    const appConfig = inject(AppConfig);
    const router = inject(Router);

    if (allowedProductionTypes.includes(appConfig.productionType)) {
      return true;
    }

    router.navigate(['Error']);

    return false;
  };
}
